var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.2C2 3.53726 2.53726 3 3.2 3H24.8C25.4627 3 26 3.53726 26 4.2C26 4.86274 25.4627 5.4 24.8 5.4H3.2C2.53726 5.4 2 4.86274 2 4.2ZM2 12.5999C2 11.9372 2.53726 11.3999 3.2 11.3999H18.8C19.4627 11.3999 20 11.9372 20 12.5999C20 13.2627 19.4627 13.7999 18.8 13.7999H3.2C2.53726 13.7999 2 13.2627 2 12.5999ZM3.2 19.8C2.53726 19.8 2 20.3373 2 21C2 21.6628 2.53726 22.2 3.2 22.2H24.8C25.4627 22.2 26 21.6628 26 21C26 20.3373 25.4627 19.8 24.8 19.8H3.2Z",
    fill: "#122B46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.154e33a0342b986841fc4b6589030741.svg";
export { ForwardRef as ReactComponent };